import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import { List } from 'semantic-ui-react';
import Link from '../../atoms/Link';
import { isExternalPage } from '../../services/pages';

var SiteMap = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(SiteMap, _React$PureComponent);

  function SiteMap() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = SiteMap.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        links = _this$props.links,
        horizontal = _this$props.horizontal,
        bulleted = _this$props.bulleted;
    return /*#__PURE__*/React.createElement(List, {
      horizontal: horizontal,
      bulleted: bulleted
    }, links.map(function (_ref) {
      var title = _ref.title,
          pageType = _ref.pageType,
          slug = _ref.slug,
          url = _ref.url,
          contentProps = _ref.contentProps;
      return /*#__PURE__*/React.createElement(List.Item, {
        key: title
      }, /*#__PURE__*/React.createElement(List.Content, null, /*#__PURE__*/React.createElement(Link, {
        to: isExternalPage(pageType) ? url : slug,
        linkAs: "span",
        title: title,
        internal: !isExternalPage(pageType),
        contentProps: contentProps
      })));
    }));
  };

  return SiteMap;
}(React.PureComponent);

export { SiteMap as default };
SiteMap.defaultProps = {
  bulleted: false,
  horizontal: false
};